import { Copy, Check } from "lucide-react";
import CustomTooltip from "../../Tooltip/CustomTooltip";

/**
 * Shared copy button used in code blocks, visualizations, and diagrams.
 * Renders the copy/check icon with consistent styling.
 *
 * @param {object} props
 * @param {boolean} props.copied - Whether text was just copied
 * @param {function} props.onClick - Click handler (should call copyToClipboard)
 * @param {string} [props.tooltip="Copy code"] - Tooltip text when not copied
 * @param {string} [props.className] - Additional button classes to merge
 */
const VizCopyButton = ({ copied, onClick, tooltip = "Copy code", className = "", variant = "solid" }) => {
  const baseClasses =
    variant === "ghost"
      ? "grid place-items-center w-7 h-7 rounded-md text-ink-gray-500 dark:text-ink-gray-400 hover:text-ink-gray-900 dark:hover:text-ink-white transition-colors"
      : "flex items-center p-2 bg-fill-white dark:bg-fill-editor-surface border-[0.5px] dark:border-edge-editor-border border-edge-border text-ink-ink dark:text-ink-white rounded-lg hover:bg-fill-gray-100 dark:hover:bg-fill-editor-hover transition-colors";

  return (
    <CustomTooltip content={copied ? "Copied!" : tooltip} side="top" align="center">
      <button type="button" aria-label={copied ? "Code copied" : tooltip} className={`${baseClasses} ${className}`} onClick={onClick}>
        {copied
          ? <Check className="w-3.5 h-3.5 transition-transform" />
          : <Copy className="w-3.5 h-3.5 hover:scale-110 transition-transform" />}
      </button>
    </CustomTooltip>
  );
};

export default VizCopyButton;
